import * as z from 'zod';

export const AuthorizeRequest = z.object({
  token: z.string().describe('The CAPTCHA token to authorize.'),
});
export const AuthorizeResponse = z.object({
  success: z
    .boolean()
    .describe('Value is `true` when authorization is successful.')
    .optional(),
  errors: z
    .object({ errorId: z.number().int().describe('ID of error.').optional() })
    .describe('Error information.')
    .optional(),
});
